import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const APP_DOWNLOAD_SELECTED = 'app_download.selected';
export const BOOKING_CONFIRMATION = 'booking_confirmation';
export const BOOKING_CONFIRMATION_PRESENTED = 'booking_confirmation.presented';
export const INBOX_MESSAGE_SELECTED = 'inbox_message.selected';
export const INBOX_PRESENTED = 'inbox.presented';
export const PROPERTY_ID_SELECTED = 'property_id.selected';
export const TRIP_COLLECTION_PRESENTED = 'trip_collection.presented';
export const TRIP_SELECTED = 'trip.selected';
export const ERROR_PRESENTED = 'error_message.presented';
export const ERROR_ALERT_CLOSED = 'error_message.alert.closed';

// ACTION LOCATIONS
export const TRIP_DETAILS = 'trip_details';
export const TRIPS = 'trips';
export const INBOX = 'inbox';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data,
    });
};

export const appDownloadSelected = ({actionLocation}) => {
    triggerEdap(APP_DOWNLOAD_SELECTED, {
        action_location: actionLocation,
    });
};

export function getTagCommanderPayload(triggerPayload) {
    return {
        edap_bidtarget: triggerPayload?.bid_target || '',
        edap_eg_true_value_amount_local:
            triggerPayload?.eg_true_value_amount_local || '',
        edap_action_location: triggerPayload?.action_location || '',
        reservation_id: triggerPayload?.reservation_id || '',
        event_page_funnel_location:
            triggerPayload?.event_page_funnel_location || '',
        book_date: triggerPayload?.book_date || '',
        booking_flow: triggerPayload?.booking_flow || '',
        booking_window: triggerPayload?.booking_window || '',
        edap_currency: triggerPayload?.currency || '',
        edap_displaycurrency: triggerPayload?.displaycurrency || '',
        displayquotetotal: triggerPayload?.displayquotetotal || 0,
        edap_date_end: triggerPayload?.eventenddate || '',
        edap_date_start: triggerPayload?.eventstartdate || '',
        full_order_rental_rate: triggerPayload?.fullorderrentalrate || 0,
        edap_item1: triggerPayload?.item1 || '',
        edap_item2: triggerPayload?.item2 || '',
        edap_item3: triggerPayload?.item3 || '',
        edap_item4: triggerPayload?.item4 || '',
        edap_latitude: triggerPayload?.latitude || 0.0,
        edap_lengthofstay: triggerPayload?.lengthofstay || 0,
        listing_id: triggerPayload?.listing_id || '',
        edap_longitude: triggerPayload?.longitude || 0.0,
        edap_adult_count: triggerPayload?.numadults || 0,
        edap_child_count: triggerPayload?.numchildren || 0,
        edap_payment_split: triggerPayload?.paymentsplit || '',
        propertytype: triggerPayload?.propertytype || '',
        withpets: triggerPayload?.withpets || false,
        admin1: triggerPayload?.admin1 || '',
        country: triggerPayload?.country || '',
        geoname: triggerPayload?.geoname || '',
        lbsuuid: triggerPayload?.lbsuuid || '',
        locality: triggerPayload?.locality || '',
        lodging_directory_id: triggerPayload?.lodging_directory_id || '',
    };
}

export const bookingConfirmationPresented = (properties) => {
    const payload = {
        bid_target: properties?.bidTarget || '',
        eg_true_value_amount_local: properties?.egTrueValueAmountLocal || '',
        action_location: properties?.action_location || '',
        event_page_funnel_location: 'confirmation',
        book_date: properties?.book_date || '',
        booking_flow: properties?.booking_flow || '',
        booking_window: properties?.booking_window || '',
        currency: properties?.currency || '',
        displaycurrency: properties?.displaycurrency || '',
        displayquotetotal: properties?.displayquotetotal || 0,
        eventenddate: properties?.eventenddate || '',
        eventstartdate: properties?.eventstartdate || '',
        fullorderrentalrate: properties?.fullorderrentalrate || 0,
        item1: properties?.item1 || '',
        item2: properties?.item2 || '',
        item3: properties?.item3 || '',
        item4: properties?.item4 || '',
        latitude: properties?.latitude || 0.0,
        lengthofstay: properties?.lengthofstay || 0,
        listing_id: properties?.listing_id || '',
        longitude: properties?.longitude || 0.0,
        numadults: properties?.numadults || 0,
        numchildren: properties?.numchildren || 0,
        paymentsplit: properties?.paymentsplit || '',
        propertytype: properties?.propertytype || '',
        reservation_id: properties?.reservation_id || '',
        withpets: properties?.withpets || false,
        admin1: properties?.admin1 || '',
        country: properties?.country || '',
        geoname: properties?.geoname || '',
        lbsuuid: properties?.lbsuuid || '',
        locality: properties?.locality || '',
        lodging_directory_id: properties?.lodging_directory_id || '',
    };
    triggerEdap(BOOKING_CONFIRMATION_PRESENTED, properties);

    try {
        if (properties?.booking_flow === 'OLB') {
            if (
                window &&
                window.tC &&
                window.tC.event &&
                window.tC.event.bookingConfirmationPresented &&
                typeof window.tC.event.bookingConfirmationPresented ===
                    'function'
            ) {
                window.tC.event.bookingConfirmationPresented(
                    this,
                    getTagCommanderPayload(payload)
                );
            }
        }
    } catch (error) {
        console.error(
            'An error occurred during TagCommander event call :',
            error
        );
    }
};

export const inboxMessageSelected = ({actionLocation}) => {
    triggerEdap(INBOX_MESSAGE_SELECTED, {
        action_location: actionLocation,
    });
};

export const inboxPresented = ({actionLocation}) => {
    triggerEdap(INBOX_PRESENTED, {
        action_location: actionLocation,
    });
};

export const propertyIdSelected = ({
    actionLocation,
    listingId,
    reservationUuid,
}) => {
    triggerEdap(PROPERTY_ID_SELECTED, {
        action_location: actionLocation,
        listing_id: listingId,
        reservation_id: reservationUuid || '-1',
    });
};

export const tripCollectionPresented = (actionLocation) => {
    triggerEdap(TRIP_COLLECTION_PRESENTED, {
        action_location: actionLocation,
    });
};

export const tripSelected = ({actionLocation, reservationUUID}) => {
    triggerEdap(TRIP_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
    });
};

export const errorPresented = ({actionLocation, key}) => {
    triggerEdap((key ? `${key}.` : '') + ERROR_PRESENTED, {
        action_location: actionLocation,
    });
};

export const errorAlertClosed = ({actionLocation, key}) => {
    triggerEdap((key ? `${key}.` : '') + ERROR_ALERT_CLOSED, {
        action_location: actionLocation,
    });
};
